<template>
  <div>
    <table class="table secondary-table table-bordered">
      <thead>
        <tr>
          <th>Stock</th>
          <th>Entry Price</th>
          <th>Target Price</th>
          <th>Potential Upside</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in kapitmansCorner.stockRecommendationList" :key="index">
          <td class="w-25">{{item.stockSymbol}}</td>
          <td class="w-25 text-right">{{item.entryPrice}}</td>
           <td class="w-25 text-right">{{item.targetPrice}}</td>
        <td class="w-25 text-right">{{item.potentialUpside}}</td>
        </tr>
       
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    data() {
        return {
            
        }
    },
 computed: {
    ...mapState({
       kapitmansCorner: (state) => state.philstocksResearch.KapitsmanCornerContent,
    }),
  },


};
</script>

<style>
</style>